"use client";

import { FC } from "react";
import { PriceChange } from "../ClpStockCards/PriceChange";
import { PriceDisplay } from "../ClpStockCards/PriceDisplay";
import { StockLogo } from "../ClpStockCards/StockLogo";
import { CHAR_LIMITS, textEllipsis } from "../ClpStockCards/clpCardConstant";
import { PayLaterMtfStockItem } from "./PayLatermtfTypes";

interface PayLaterMtfContentProps {
  stock: PayLaterMtfStockItem;
  defaultImage?: string;
  onModalStateChange?: (isOpen: boolean) => void;
  modalTitle?: string;
  modalBtnCta?: string;
  successMsg?: string;
  errorMsg?: string;
}

export const PayLaterMtfContent: FC<PayLaterMtfContentProps> = ({
  stock,
  defaultImage,
  onModalStateChange,
  modalTitle,
  modalBtnCta,
  successMsg,
  errorMsg,
}) => {
  const { perChange, logoURL, ltp, changePrice } = stock;
  const isPositive = Number(perChange) >= 0;

  return (
    <div className="flex w-full min-w-0 cursor-pointer flex-col gap-3 overflow-hidden rounded-lg">
      <div className="flex w-full min-w-0 flex-col gap-2">
        <div className="flex w-full min-w-0 flex-col">
          <StockLogo
            logoURL={logoURL || defaultImage}
            defaultImage={defaultImage}
            symbol={stock.symbol}
            stock={stock}
            onModalStateChange={onModalStateChange}
            modalTitle={modalTitle}
            modalBtnCta={modalBtnCta}
            successMsg={successMsg}
            errorMsg={errorMsg}
          />
        </div>

        <h2 className="stock-symbol min-w-0 truncate text-[14px] font-normal leading-[1.179] text-[#1a1a1a] sm:text-[16px] sm:leading-[1.031]">
          {textEllipsis(
            stock.symbol || "stock",
            CHAR_LIMITS.STOCK_TITLE,
            "stock-symbol",
          )}
        </h2>
      </div>

      <div className="flex min-w-0 flex-col gap-1 overflow-hidden">
        <PriceDisplay ltp={ltp} isPositive={isPositive} />
        <PriceChange
          changePrice={changePrice}
          perChange={perChange}
          className="md:text-[14px]"
        />
      </div>
    </div>
  );
};
